import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { listZones, type ZoneRow } from '../../api/orgApi.js';
import { DataGrid } from '../../components/DataGrid.js';
import { ListShell, StatusBadge, sx } from './orgKit.js';

export function ZoneListPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<ZoneRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listZones(token)
      .then((r) => setRows(r.data))
      .catch((e) => setError((e as Error).message))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <ListShell
      label="zone-list"
      title={t('org.zone.list.title')}
      newTo="/org/zones/new"
      newLabel={t('org.zone.list.new')}
      error={error}
      loading={loading}
      empty={!loading && rows.length === 0}
      emptyText={t('org.zone.list.empty')}
    >
      {rows.length > 0 && (
        <DataGrid<ZoneRow>
          caption="zones"
          rows={rows}
          getRowId={(z) => z.zoneId}
          rowTestId={(z) => `zone-${z.zoneId}`}
          searchPlaceholder={t('org.common.searchNameCode')}
          columns={[
            {
              key: 'code',
              header: t('org.col.code'),
              value: (z) => z.zoneCode,
              render: (z) => (
                <Link to={`/org/zones/${z.zoneId}/edit`} style={sx.link}>{z.zoneCode}</Link>
              ),
            },
            { key: 'name', header: t('org.col.name'), value: (z) => z.zoneName },
            {
              key: 'status',
              header: t('org.col.status'),
              value: (z) => z.recordStatusCode,
              render: (z) => <StatusBadge status={z.recordStatusCode} />,
            },
          ]}
        />
      )}
    </ListShell>
  );
}
